module.exports = __webpack_public_path__ + "static/img/C4D0030.25da484.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0030.jpg
// module id = Y+WA
// module chunks = 0